/* global Loader:true $:true */

import debug from "debug";
const MODULE_NAME = 'app.core/lib/strings';
const log = debug(MODULE_NAME);


export function toCamelCase (str) {
	return str.replace(/^([A-Z])|[\s-_](\w)/g, (match, p1, p2) => {
		if (p2) {
			return p2.toUpperCase();
		}

		return p1.toLowerCase();
	});
}

export function tmpl (str, context) {
	let result = str;

	log(`templating ${result} with context: `, context);

	if (result) {

		Object.keys(context)
			.forEach((item) => {
				result = result.replace(`{{${item}}}`, context[item]);
			});

		log(`templated ${result}`);
	}

	return result;
}

export function $tmpl (element, context) {
    const $target = $(element);
    const templateString = $target.attr('data-text-template');

    log(`templating [${templateString}] with context: `, context);
    const result = tmpl(templateString, context);

    $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
export function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  function get (ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return (0 in path) ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : (self ? [self] : []);
  self = invert ? (0 in self) ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = (typeof self[i] == "object") ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = {"": self[i]};

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g,
      function(match, code, y, z, close, invert, name) {
        if (!depth) {
          output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g,
            function(match, raw, comment, isRaw, partial, name) {
              return raw ? get(ctx, raw)
                : isRaw ? get(ctx, name)
                : partial ? render(get(ctx, name), ctx)
                : !comment ? new Option(get(ctx, name)).innerHTML
                : "";
            }
          );
          inverted = invert;
        } else {
          childCode += depth && !close || depth > 1 ? match : code;
        }
        if (close) {
          if (!--depth) {
            name = get(ctx, name);
            if (/^f/.test(typeof name)) {
              output += name.call(ctx, childCode, function (template) {
                return render(template, ctx);
              });
            } else {
              output += render(childCode, name, ctx, inverted);
            }
            childCode = "";
          }
        } else {
          ++depth;
        }
      }
    );
  }
  return output;
}




// WEBPACK FOOTER //
// ./project/client/src/core/modules/search-dropdown/strings.js